import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  bgColor?: string;
}

const CheckCircleBgIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.49976 14.4999C8.49976 9.52938 12.5292 5.49994 17.4998 5.49994C22.4703 5.49994 26.4998 9.52938 26.4998 14.4999C26.4998 19.4705 22.4703 23.4999 17.4998 23.4999C12.5292 23.4999 8.49976 19.4705 8.49976 14.4999Z"
        fill={props.bgColor || "#F1F2F2"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3077 4.38462C7.10155 4.38462 3.69235 7.79381 3.69235 12C3.69235 16.2054 7.1016 19.6154 11.3077 19.6154C15.5139 19.6154 18.9231 16.2054 18.9231 12C18.9231 7.79381 15.5139 4.38462 11.3077 4.38462ZM2.30774 12C2.30774 7.02911 6.33685 3 11.3077 3C16.2786 3 20.3077 7.02911 20.3077 12C20.3077 16.9699 16.2787 21 11.3077 21C6.33679 21 2.30774 16.9699 2.30774 12Z"
        fill={props.color || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9937 9.37947C15.264 9.64983 15.264 10.0882 14.9937 10.3585L10.7311 14.6211C10.4608 14.8914 10.0225 14.8915 9.75217 14.6212L7.61999 12.4899C7.34957 12.2196 7.34948 11.7812 7.61978 11.5109C7.8901 11.2404 8.32844 11.2403 8.59885 11.5106L10.2415 13.1526L14.0146 9.37947C14.2849 9.1091 14.7233 9.1091 14.9937 9.37947Z"
        fill={props.color || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default CheckCircleBgIcon;
